import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Spin, Table, Button, Card } from 'antd';
import { Link } from 'react-router-dom';

import ALL_QUERY from '../../graphql/queries/getCustomerPbasQuery.graphql';

import PresentBankingArrangementForm from '../../forms/PresentBankingArrangementForm';
import CustomerDocUpload from '../../components/CustomerDocUpload';
import { currencyFormat } from '../../utils/globals';

const { Column } = Table;

const PresentBankingArrangements = (props) => {
  const { loading, customerPbas } = props.data;
  if (loading) {
    return (
      <Spin size="large" />
    );
  }
  const customerId = props.match.params.id;

  let totalSanction = 0;
  customerPbas.forEach((record) => {
    totalSanction += record.sanction_bg_lc + record.sanction_tl + record.sanction_cc;
  });

  return (
    <div>
      <h2 className="page-title">Factsheet - Present Banking Arrangements</h2>
      <Card title="View All" bordered={false} className="ec-card">
        <p><strong>Total Sanction of all Banks = </strong>{currencyFormat(totalSanction)}</p>
        <Table dataSource={customerPbas} rowKey="id">
          <Column
            title="Bank Name"
            dataIndex="bank_name"
            key="bank_name"
          />
          <Column
            title="Sanction Total"
            key="sanction_total"
            render={(text, record) => currencyFormat(record.sanction_bg_lc + record.sanction_tl + record.sanction_cc)}
          />
          <Column
            title="Actions"
            key="actions"
            render={(text, record) => (
              <div>
                <Button style={{ marginRight: 10 }}>
                  <Link to={`${props.match.url}/${record.id}/rs`}>
                    Repayment Schedule
                  </Link>
                </Button>
                <Button style={{ marginRight: 10 }}>
                  <Link to={`${props.match.url}/${record.id}/securities`}>
                    Securities
                  </Link>
                </Button>
                <Button>
                  <Link to={`${props.match.url}/${record.id}/loanStatements`}>
                    Loan Statements
                  </Link>
                </Button>
              </div>
            )}
          />
          <Column
            title="Documents to be uploaded"
            key="documents"
            render={(text, record) => (
              <div>
                {
                  (record.sanction_letter_doc && !record.sanction_letter_doc.uploaded) ?
                    <div style={{ display: 'inline-block', marginRight: 10 }}>
                      <CustomerDocUpload task_id={record.sanction_letter_doc.task.id} customerDoc={record.sanction_letter_doc} customer_id={customerId} buttonText="Sanction Letter" />
                    </div>
                    :
                    null
                }
              </div>
            )}
          />
        </Table>
      </Card>
      <Card title="Create new PBA" bordered={false} className="ec-card">
        <PresentBankingArrangementForm customer_id={customerId} />
      </Card>
    </div>
  );
};

PresentBankingArrangements.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    customerPbas: PropTypes.array,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default graphql(ALL_QUERY, {
  options: ({ match }) => ({ variables: { customer_id: match.params.id } }),
})(PresentBankingArrangements);



// WEBPACK FOOTER //
// ./src/pages/factsheet/PresentBankingArrangements.jsx